import React, { useMemo, useState, useEffect, Fragment } from 'react';
import { PageHeader, Row, Col, Spin, Modal as ModalAntd } from 'antd';
import Modal from '../../../components/Modal';
import { getAccesTokenApi } from '../../../api/auth';
import { getSupplierApi } from '../../../api/supplier';
import DataTable from 'react-data-table-component';
import { DownloadExcel } from "react-excel-export";
import axios from 'axios';
import reacparser from 'react-xml-parser'
import VatWithholding from '../../../components/Admin/Suppliers/VatWithholding';
import './SupplierDetail.scss';
import IcaWithholding from '../../../components/Admin/Suppliers/ICAWithholding';
import SourceWithholding from '../../../components/Admin/Suppliers/SourceWithholding';
import { parse } from 'query-string';


const { confirm } = ModalAntd;



export default function SupplierDetail(props) {
	const { match } = props;
	const id_proveedor = match.params.id;
	const [supplier, setSupplier] = useState([]);
	const [reloadSupplier, setReloadSupplier] = useState(true);
	const [isVisibleModal, setIsVisibleModal] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const [modalContent, setModalContent] = useState(null);
	const token = getAccesTokenApi();

	useEffect(() => {
		getSupplierApi(token, id_proveedor).then((response) => {
			if (response.estado === 'OK') {
				setSupplier(response.resultado);
			} else {
				setSupplier([]);
			}
			setReloadSupplier(false);
		});
	}, token);


	const toCurrency = (numberString) => {
		let number = parseFloat(numberString);
		return number.toLocaleString('COP');
	}

	const [list, setList] = useState([]);
	useEffect(() => {
		axios({
			method: 'get',
			headers: { 'Access-Control-Allow-Origin': '*', 'Content-Type': 'multipart/form-data', 'Accept': 'application/json', 'type': 'formData' },
			url: 'https://proveedoresapi.azurewebsites.net/api/ObtenerPagos?nit=' + id_proveedor
		})
			.then((Response) => {
				setList(Response.data);

			}).catch((error) => {
				console.log(error)
			})
	}, [setList]);

	const [pagosProveedor, setPagosProveedor] = useState([]);
	useEffect(() => {
		axios({
			method: 'get',
			url: 'https://cia.icontec.org/soapws/consulta_pagos.php?nit=' + id_proveedor
		})
			.then((res) => {
				const jsonString = Object.assign([res.data.G_1],)
			
			
				if(jsonString[0].length > 1){
					console.log('repuesta opps')
					console.log(res.data.G_1)
					setPagosProveedor(res.data.G_1)
				}else{
					console.log("Aqui con indice")
					console.log(jsonString)
					setPagosProveedor(jsonString)
				}

			})
			.catch((error) => {
				console.log(error)
			})
	}, [setPagosProveedor]);

	const [ppsProveedor, setPpsProveedor] = useState([]);
	useEffect(() => {
		axios({
			method: 'get',
			url: 'https://cia.icontec.org/soapws/consulta_pps.php?nit=' + id_proveedor
		})
			.then((res) => {
				const jsonString = Object.assign([res.data.G_1],)
				if(jsonString[0].length > 1){
					console.log('repuesta opps')
					console.log(res.data.G_1)
					setPpsProveedor(res.data.G_1)
				}else{
					console.log("Aqui con indice")
					console.log(jsonString)
					setPpsProveedor(jsonString)
				}	
			})
			.catch((error) => {
				console.log(error)
			})
	}, [setPpsProveedor]);

	const [cuentasProveedor, setCuentasProveedor] = useState([]);
	useEffect(() => {
		axios({
			method: 'get',
			url: 'https://cia.icontec.org/soapws/consulta_cxp.php?nit=' + id_proveedor
		})
			.then((res) => {
				console.log('repuesta cxp')
				const jsonString = Object.assign([res.data.G_1],)
				if(jsonString[0].length > 1){
					console.log('repuesta cuentas')
					console.log(res.data.G_1)
					setCuentasProveedor(res.data.G_1)
				}else{
					console.log("Aqui con indice")
					console.log(jsonString)
					setCuentasProveedor(jsonString)
				}
			})
			.catch((error) => {
				console.log(error)
			})
	}, [setCuentasProveedor]);


	const columnsCuentas = [
		{
			name: 'NIT',
			selector: row => row.NIT,
			right: true,
		},
		{
			name: 'Proveedores',
			selector: row => row.PROVEEDOR,
			style: {
				backgroundColor: 'rgba(187, 204, 221, 1)',
			},
			right: true,
		},
		{
			name: 'Numero De factura',
			selector: row => row.FACTURA,
			right: true,
		},
		{
			name: 'Fecha Radicacion',
			selector: row => row.FECHA_RADICACION,
			sortable: true,
			style: {
				backgroundColor: 'rgba(187, 204, 221, 1)',
		},
		right: true,
		},
		{
			name: 'Valor Factura',
			selector: row => toCurrency(row.MONTO_ORIGINAL),
			style: {
				textAlign: 'center'
			},
			sortable: true,
			right: true,
			

			Cell: props => <div> toCurrency(props.value) </div>
		},
		{
			name: 'Valor Pendiente De Pago',
			selector: row => toCurrency(row.SALDO_PENDIENTE),
			sortable: true,
			style: {
				backgroundColor: 'rgba(187, 204, 221, 1)',
			},
			right: true,
		}
	];


	const columnsPago = [
		{
			name: 'NIT',
			selector: row => row.NIT,
			sortable: true,
			right: true,
		},
		{
			name: 'Fecha Pago',
			selector: row => row.FECHA_PAGO,
			sortable: true,
			style: {
				backgroundColor: 'rgba(187, 204, 221, 1)',
			},
			right: true,

		},
		{
			name: 'Numero Factura',
			selector: row => row.NUM_FACTURA,
			sortable: true,
			right: true,
		},
		{
			name: 'Valor Pagado',
			selector: row => toCurrency(row.MONTO_DEL_PAGO),
			sortable: true,
			style: {
				backgroundColor: 'rgba(187, 204, 221, 1)',
			},
			right: true,

		},
		{
			name: 'ICA',
			selector: row => toCurrency(row.AP_ICA),
			sortable: true,
			right: true,
		},
		{
			name: 'R. Fuente',
			selector: row => toCurrency(row.AP_RET),
			sortable: true,
			style: {
				backgroundColor: 'rgba(187, 204, 221, 1)',
			},
			right: true,
		},
		{
			name: 'Valor Descontado',
			selector: row => toCurrency(row.SUMA_TOTAL_DESCUENTO),
			sortable: true,
			right: true,
		}
	];

	const columnsPps = [
		{
			name: 'Cantidad',
			selector: row => row.CANTIDAD,
			sortable: true,
			right: true,
		},
		{
			name: 'Cliente',
			selector: row => row.CLIENTE,
			sortable: true,
			right: true,
			
		},
		{
			name: 'Proveedor',
			selector: row => row.PROVEEDOR,
			sortable: true,
			right: true,
		},
		{
			name: 'Articulo',
			selector: row => row.DESCRIPCION_ARTICULO,
			sortable: true,
			right: true,
		},
		{
			name: 'Fecha Inicio Servicio',
			selector: row => row.FECHA_INICIO_SERVICIO,
			sortable: true,
			right: true,
		},
		{
			name: 'Fecha Fin Servicio',
			selector: row => row.FECHA_FIN_SERVICIO,
			sortable: true,
			right: true,
		},
		{
			name: 'Fecha Orden',
			selector: row => row.FECHA_ORDEN,
			sortable: true,
			right: true,
		},
		{
			name: 'PROYECTO',
			selector: row => row.NUMERO_PROYECTO,
			sortable: true,
			right: true,
		},
		{
			name: 'TAREA',
			selector: row => row.NUMERO_TAREA,
			sortable: true,
			right: true,
		},
		{
			name: 'ORDEN',
			selector: row => row.NUM_ORDEN,
			sortable: true,
			right: true,
		},
		{
			name: 'NUM_RECEPCION',
			selector: row => row.NUM_RECEPCION,
			sortable: true,
			right: true,
		},
		{
			name: 'SUBTOTAL',
			selector: row => row.SUBTOTAL,
			sortable: true,
			right: true,
		},
		{
			name: 'TOTAL_IMPTOS',
			selector: row => row.TOTAL_IMPTOS,
			sortable: true,
			right: true,
		},
		{
			name: 'VALOR_LINEA',
			selector: row => row.TOTAL_VALOR_LINEA,
			sortable: true,
			right: true,
		},
		{
			name: 'MONEDA',
			selector: row => row.MONEDA,
			sortable: true,
			right: true,
		}
	];
	const customStyles = {
		rows: {
			style: {
				minHeight: '72px', // override the row height
			},
		},
		headCells: {
			style: {
				paddingLeft: '8px', // override the cell padding for head cells
				paddingRight: '8px',
			},
		},
		cells: {
			style: {
				paddingLeft: '8px', // override the cell padding for data cells
				paddingRight: '8px',
				cell : '8px'
			},
		},
	};

	return (
		<Fragment>
			<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@3.4.1/dist/css/bootstrap.min.css" integrity="sha384-HSMxcRTRxnN+Bdg0JdbxYKrThecOKuH5zCYotlSAcp1+c8xmyTe9GYg1l9a69psu" crossorigin="anonymous"></link>

			<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@3.4.1/dist/css/bootstrap-theme.min.css" integrity="sha384-6pzBo3FDv/PJ8r2KRkGHifhEocL+1X2rVCTTkUfGk7/0pbek5mMa1upzvWbrUbOZ" crossorigin="anonymous"></link>

			<script src="https://cdn.jsdelivr.net/npm/bootstrap@3.4.1/dist/js/bootstrap.min.js" integrity="sha384-aJ21OjlMXNL5UyIl/XNwTMqvzeRMZH2w8c5cRVpzpU8Y5bApTppSuUkhZXN0VxHd" crossorigin="anonymous"></script>
			<div className="supplier-detail">
			<a href="http://www.google.com/">
				<button>Actualizar mis datos</button>
				</a>
				<Spin spinning={reloadSupplier}>
					<PageHeader onBack={() => props.history.goBack()} title="Información de Certificados" />
					
					<VatWithholding
						id={id_proveedor}
						setIsVisibleModal={setIsVisibleModal}
						setModalTitle={setModalTitle}
						setModalContent={setModalContent}
					/>
					<IcaWithholding
						id={id_proveedor}
						setIsVisibleModal={setIsVisibleModal}
						setModalTitle={setModalTitle}
						setModalContent={setModalContent}
					/>
					<SourceWithholding
						id={id_proveedor}
						setIsVisibleModal={setIsVisibleModal}
						setModalTitle={setModalTitle}
						setModalContent={setModalContent}
					/>
					<Modal title={modalTitle} isVisible={isVisibleModal} setIsVisible={setIsVisibleModal} width="75%">
						{modalContent}
					</Modal>

				</Spin>

				
			</div>
				
				<DataTable
					title="Información de Cuentas Por Pagar"
					columns={columnsCuentas}
					data={cuentasProveedor}
					pagination
				
				/>

				<DataTable
					title="Información de Pagos Realizados"
					columns={columnsPago}
					data={pagosProveedor} 
					pagination
					customStyles={customStyles}
					/>	
					


		</Fragment>
	)
}
